var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import styles from './FieldLabelAttributes.scss';
import WixComponent from '../BaseComponents/WixComponent';
import Tooltip from '../Tooltip';
import Info2 from '../Icons/dist/components/Info2';

var FieldLabelAttributes = function (_WixComponent) {
  _inherits(FieldLabelAttributes, _WixComponent);

  function FieldLabelAttributes() {
    _classCallCheck(this, FieldLabelAttributes);

    return _possibleConstructorReturn(this, (FieldLabelAttributes.__proto__ || Object.getPrototypeOf(FieldLabelAttributes)).apply(this, arguments));
  }

  _createClass(FieldLabelAttributes, [{
    key: 'render',
    value: function render() {
      var requiredAstrix = React.createElement('span', { 'data-hook': 'required', className: styles.required });
      var infoTooltip = React.createElement(
        Tooltip,
        {
          appendToParent: true,
          content: this.props.info,
          theme: 'light',
          alignment: 'center',
          moveBy: { x: 2, y: 2 },
          hideDelay: 0
        },
        React.createElement(
          'span',
          { 'data-hook': 'info', className: styles.icon },
          React.createElement(Info2, { size: '18px' })
        )
      );

      return React.createElement(
        'div',
        { className: styles.root, 'data-hook': 'field-label-attributes' },
        this.props.required ? requiredAstrix : null,
        this.props.info ? infoTooltip : null
      );
    }
  }]);

  return FieldLabelAttributes;
}(WixComponent);

FieldLabelAttributes.defaultProps = {
  required: false,
  info: ''
};

FieldLabelAttributes.propTypes = {
  required: PropTypes.bool,
  info: PropTypes.string
};

export default FieldLabelAttributes;
//# sourceMappingURL=FieldLabelAttributes.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/FieldLabelAttributes/FieldLabelAttributes.js